import type {
  RecommendationPlacement,
  PlacementSetting,
  ActiveRecommendation,
} from '@parentpath/supabase-client';

/**
 * Fallback defaults for each placement when the admin hasn't specified
 * per-placement settings (e.g. for recommendations created before the
 * settings column was introduced).
 */
export const PLACEMENT_DEFAULTS: Record<RecommendationPlacement, PlacementSetting> = {
  ssw_content: { variant: 'compact', position: 'before_text' },
  baby_development: { variant: 'compact', position: 'after_milestones' },
  checklist_detail: { variant: 'compact', position: 'random' },
  wissenswertes_pregnancy: { variant: 'extended', position: 'random' },
  wissenswertes_baby: { variant: 'extended', position: 'random' },
};

export function getPlacementSetting(
  rec: ActiveRecommendation | null | undefined,
  placement: RecommendationPlacement
): PlacementSetting {
  const configured = rec?.placement_settings?.[placement];
  if (configured) return configured;
  return PLACEMENT_DEFAULTS[placement];
}
